import React, { useMemo } from 'react';
import SmallChart from '@op/pages/Overview/KeyMetrics/MentionsSentiment/components/SmallChart';
import { reviewsFormat } from '@op/utils/value';

export default function PRSmallChart({
  statistics,
  text,
  dateType,
}: {
  statistics?: { x: never[]; y: never[]; };
  text: string;
  dateType?: string;
}) {

  const noEmpty = useMemo(() => {
    const { y } = statistics || {};
    return y?.find((val: number) => val);
  }, [statistics]);

  return (
    <div className="dbo-pr-chart dbo-pr-small-chart">
      {
        noEmpty && (
          <SmallChart
            text={''}
            statistics={statistics}
            topicName={text}
            formatValueFunc={(value: number) => reviewsFormat(value)}
            dateType={dateType}
          />
        )
      }
    </div>
  );
}
